import React from 'react';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  CardActions,
  Box,
  Snackbar
} from '@mui/material';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product }) => {
  const [open, setOpen] = React.useState(false);
  const { addToCart } = useCart();

  return (
    <Card
      sx={{
        position: 'relative',
        transition: 'transform 0.3s, box-shadow 0.3s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 8px 16px rgba(184, 134, 11, 0.2)',
        },
        borderRadius: '12px',
        overflow: 'hidden',
        background: 'linear-gradient(145deg, #ffffff 0%, #fff8e7 100%)',
      }}
    >
      {product.onSale && (
        <Box
          sx={{
            position: 'absolute',
            top: 16,
            left: 16,
            backgroundColor: '#ff3d3d',
            color: 'white',
            padding: '4px 12px',
            borderRadius: '20px',
            zIndex: 1,
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            fontWeight: 'bold'
          }}
        >
          SALE
        </Box>
      )}
      <CardMedia
        component="img"
        height="250"
        image={product.image}
        alt={product.name}
        sx={{ objectFit: 'scale-down' }}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'serif' }}>
          {product.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {product.description}
        </Typography>
        <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          {product.onSale ? (
            <>
              <Typography
                variant="h6"
                color="error"
                sx={{ fontWeight: 'bold' }}
              >
                ${product.salePrice.toFixed(2)}
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ textDecoration: 'line-through' }}
              >
                ${product.originalPrice.toFixed(2)}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  backgroundColor: '#ff3d3d',
                  color: 'white',
                  padding: '2px 6px',
                  borderRadius: '4px',
                  ml: 'auto'
                }}
              >
                {Math.round(((product.originalPrice - product.salePrice) / product.originalPrice) * 100)}% OFF
              </Typography>
            </>
          ) : (
            <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold' }}>
              ${product.price.toFixed(2)}
            </Typography>
          )}
        </Box>
      </CardContent>
      <CardActions sx={{ padding: 2 }}>
        <Button
          size="large"
          variant="contained"
          fullWidth
          onClick={() => {
            addToCart(product);
            setOpen(true);
          }}
          sx={{
            background: 'linear-gradient(90deg, #B8860B 0%, #DAA520 100%)',
            color: 'white',
            '&:hover': {
              background: 'linear-gradient(90deg, #DAA520 0%, #B8860B 100%)',
            }
          }}
        >
          Add to Cart
        </Button>
      </CardActions>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
        message={`${product.name} added to cart`}
      />
    </Card>
  );
};

export default ProductCard;
